export enum TipoCarrera
{
    Incompleta = "Incompleta",
    Egresado = "Egresado",
    Titulado = "Titulado",
}